import { TRootState } from "Redux/Reducers";

export const getLastEventTicketId = (state: TRootState) => state.eventTicket.lastUpdateId;
